// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"vx-z","smallCardRow":"wx-z","largeCardRow":"xx-z","productSearchRow":"yx-z","curatedRow":"zx-z"};